<template>
  <div class="form-group form-group--read-only">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}</label>
        <div class="lead" v-if="values">
          <ul class="list-unstyled">
            <li v-for="item in values"
                v-bind:key="item.value"
            >{{ item.label }}</li>
          </ul>
        </div>
        <div class="lead" v-else>
          <span class="text">-</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['component', 'components', 'value'],
  name: 'CheckboxReadOnly',
  data () {
    return {
      values: [],
      checked: null
    }
  },
  methods: {
    getValue: function () {
      if (Array.isArray(this.value)) {
        this.values = this.value || []
      }
    }
  },
  created () {
    this.getValue()
  }
}
</script>
